module.exports = __webpack_public_path__ + "components/flag/static/square/nc-31ec48d4d55bf04b220ac9af7ff9bd71.svg";